import "./App.css";
import Home from "./Pages/Home";
import Navbar from "./Components/Navbar";
import { BrowserRouter, Routes, Route } from "react-router-dom";

import ScrollToTop from "./ScrollToTop";
import OurDashboard from "./Pages/OurDashboard";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <ScrollToTop>
          {/* <Navbar /> */}
          <Routes>
            <Route
              path="/press-releases"
              exact
              element={<OurDashboard type="pressReleases" />}
            />
            <Route
              path="/earnings-calendar"
              exact
              element={<OurDashboard type="earningsCalendar" />}
            />
            <Route
              path="/complete__details/stock/:symbol"
              exact
              element={<OurDashboard type="stockDetails" />}
            />
            {/* <Route
              path="/compare__details/stock/:symbol"
              exact
              element={<OurDashboard isMain={false} />}
            /> */}
            <Route
              path="/All-Stocks"
              exact
              element={<OurDashboard type="allStocks" />}
            />
            <Route path="/" exact element={<Home />} />
          </Routes>
        </ScrollToTop>
      </BrowserRouter>
    </div>
  );
}

export default App;
